import { logFeature } from '@office-start/telemetry-service';
import { getPageTimings } from '@office-start/ttvr-performance-service';
/**
 * Used to log params received from Hub SDK
 * @param params object type AppHostInstrumentationParams
 */
export const logAppHostMetrics = ({ appId, scenarioName, clientTimeStamp = 0, tileChanged = false, appUrl = '', appSearchParams = '', appHostSessionId = '', isStandaloneApp = false, resourceDeliveryType = '', }) => {
    var _a, _b;
    const appSearchParamsLowerCase = new URLSearchParams(appSearchParams ? appSearchParams === null || appSearchParams === void 0 ? void 0 : appSearchParams.toLowerCase() : '');
    const messageDelayMs = clientTimeStamp ? Date.now() - clientTimeStamp : 0;
    logFeature({
        featureName: "MOSHub" /* KnownFeatureNames.MOSHub */,
        eventName: "MOS_Hub_SDK_Request" /* KnownFeatureInstrumentationEvents.MOSHubSDK */,
        params: {
            AppId: appId,
            ClientTimeStamp: clientTimeStamp,
            MessageDelayMs: messageDelayMs,
            MOSHubScenarioName: scenarioName,
            IsTileChange: tileChanged,
            AppUrl: appUrl,
            AppHostSessionId: appHostSessionId,
            FromCode: (_a = appSearchParamsLowerCase === null || appSearchParamsLowerCase === void 0 ? void 0 : appSearchParamsLowerCase.get('fromcode')) !== null && _a !== void 0 ? _a : '',
            RedirectId: (_b = appSearchParamsLowerCase === null || appSearchParamsLowerCase === void 0 ? void 0 : appSearchParamsLowerCase.get('redirectid')) !== null && _b !== void 0 ? _b : '',
            IsStandaloneApp: isStandaloneApp,
            ResourceDeliveryType: resourceDeliveryType,
        },
        area: 'MOSAppHost',
        subArea: 'MOSAppHostMetrics',
    });
    setMetricsForPASTool(scenarioName, messageDelayMs);
};
/**
 * Used to log params received from Hub SDK
 * @param params object type AppHostInstrumentationParams
 */
export const logAppHostMetricsWithMsgDelay = (appId, scenarioName, messageDelayMs, tileChanged, appUrl, pagePrefetchRedirectionCount, isStandaloneApp, appSearchParams, resourceDeliveryType, isGovernment) => {
    var _a, _b;
    const appSearchParamsLowerCase = new URLSearchParams(appSearchParams ? appSearchParams === null || appSearchParams === void 0 ? void 0 : appSearchParams.toLowerCase() : '');
    logFeature({
        featureName: "MOSHub" /* KnownFeatureNames.MOSHub */,
        eventName: "MOS_Hub_SDK_Request" /* KnownFeatureInstrumentationEvents.MOSHubSDK */,
        params: {
            AppId: appId,
            MessageDelayMs: messageDelayMs !== null && messageDelayMs !== void 0 ? messageDelayMs : 0,
            MOSHubScenarioName: scenarioName,
            IsTileChange: tileChanged !== null && tileChanged !== void 0 ? tileChanged : false,
            AppUrl: appUrl !== null && appUrl !== void 0 ? appUrl : '',
            PagePrefetchRedirectionCount: pagePrefetchRedirectionCount !== null && pagePrefetchRedirectionCount !== void 0 ? pagePrefetchRedirectionCount : 0,
            FromCode: (_a = appSearchParamsLowerCase === null || appSearchParamsLowerCase === void 0 ? void 0 : appSearchParamsLowerCase.get('fromcode')) !== null && _a !== void 0 ? _a : '',
            RedirectId: (_b = appSearchParamsLowerCase === null || appSearchParamsLowerCase === void 0 ? void 0 : appSearchParamsLowerCase.get('redirectid')) !== null && _b !== void 0 ? _b : '',
            IsStandaloneApp: isStandaloneApp !== null && isStandaloneApp !== void 0 ? isStandaloneApp : false,
            ResourceDeliveryType: resourceDeliveryType !== null && resourceDeliveryType !== void 0 ? resourceDeliveryType : '',
            IsGovernment: isGovernment !== null && isGovernment !== void 0 ? isGovernment : false,
        },
        area: 'MOSAppHost',
        subArea: 'MOSAppHostMetrics',
    });
    setMetricsForPASTool(scenarioName, messageDelayMs);
};
/**
 *  Store the scenarios with delay in ms for PAS tool to consume
 * @param scenarioName object type AppHostInstrumentationParams
 */
const setMetricsForPASTool = (scenarioName, messageDelayMs) => {
    const pageTimings = getPageTimings();
    if (!pageTimings[scenarioName]) {
        pageTimings[scenarioName] = messageDelayMs !== null && messageDelayMs !== void 0 ? messageDelayMs : 0;
    }
};
//# sourceMappingURL=logAppHostMetrics.js.map